import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectTokenInfo } from 'app/reducers/context.selectors';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Пускает в приложение только с токенами на руках, иначе отправляет на форму
 * логина, передавая запрошенный адрес в returnUrl — после входа пользователь
 * попадёт именно туда, куда шёл.
 *
 * До этого guard'а роут 'app' был открыт для всех, а авторизацию де-факто
 * обеспечивали 401 от бэкенда: анонимный вход поднимал резолверы, те стреляли
 * в API без токена, каждый 401 приводил к signOutUser и редиректу на /auth
 * (IC-2673). Guard убирает эту пачку запросов и делает редирект детерминированным.
 *
 * Проверяем именно НАЛИЧИЕ токенов, а не срок жизни access-токена: просроченный
 * access-токен штатно обновляется в TokenInterceptorService по refresh-токену,
 * и выкидывать за это на форму логина нельзя.
 */
@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  canActivate(_route: unknown, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(selectTokenInfo).pipe(
      take(1),
      map(tokenInfo => {
        if (tokenInfo?.token && tokenInfo?.refreshToken) {
          return true;
        }

        return this.router.createUrlTree(['auth'], {
          queryParams: {returnUrl: state.url},
        });
      }),
    );
  }
}
